import React from 'react'
import Modal from 'react-modal'
import { InputField } from '../componentsBarrel'

import '../Styles/dialogButtons.css'
import './journalArticleAuthorModal.css'

export class JournalArticleAuthorModal extends React.Component {

    constructor(props) {
        super(props)

        this.showDelete = props.item ? true : false

        this.state = {
            firstName: props.item ? props.item.firstName : '',
            lastName: props.item ? props.item.lastName : '',
            edit: props.item ? true : false
        }
    }

    onRequestClose = (e) => {
        e.preventDefault();
        this.props.onRequestClose();
    }

    onRequestDelete = (e) => {
        e.preventDefault();
        let data = {
            ...this.state,
            deleteRequested: true
        }
        this.onRequestClose(e);
        this.props.onClose(data, this.props.parent);

    }

    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!this.validate()) {
            return false;
        }

        this.onRequestClose(e);
        this.props.onClose(this.state, this.props.parent);
    }

    validate() {
        return true;
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    getDeleteButton() {
        if ( this.showDelete ) {
            return (
                <button className="secondary-button" onClick={(e) => this.onRequestDelete(e)}>Delete</button>
            )
        }
    }

    render() {
        return (
            <main>
                <div className="journal-article-author-modal">
                    <Modal
                        isOpen
                        onRequestClose={this.onRequestClose}
                        handleClose={this.onRequestClose}
                        className="JournalArticleAuthorCustomModal journal-article-author-modal-main"
                        appElement={document.getElementById('root')}
                        style={{
                            overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }
                        }}
                    >
                        <h2>Author</h2>

                        <form onSubmit={this.handleSubmit}>
                            <div className="fieldContainer">
                                <div className="fieldGroup">
                                    <InputField title="First Name" 
                                        name="firstName" 
                                        onChange={this.onChange} 
                                        value={this.state.firstName} 
                                        maxLength="100"
                                        required
                                        autoFocus
                                    />
                                </div>
                                <div className="fieldGroup">
                                    <InputField title="Last Name" 
                                        name="lastName" 
                                        onChange={this.onChange} 
                                        value={this.state.lastName} 
                                        maxLength="100"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="dialogButtons">
                                <button className="default-button">Save</button>
                                <button className="secondary-button" onClick={(e) => this.onRequestClose(e)}>Cancel</button>
                                {this.getDeleteButton()}
                            </div>
                        </form>
                    </Modal>
                </div>
            </main>
        )
    }
}
